import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';
import { APP_CONSTANTS, OTIP_ENTITY } from '../../../utils/AppConstants';
import { decodeCtx } from '../../../utils/auth/ctxHelper';

export const ACTION_NAME = 'ACTION_STORE_CONTEXT';

/**
 * @description Initializes the context state from sessionStorage.
 * @param {object} logger
 * @returns {object}
 */
const initializeContextState = (logger) => {
    const storedCtx = sessionStorage.getItem(APP_CONSTANTS.MPROFILE_CTX);
    const decodedCtx = decodeCtx(storedCtx, logger);

    if (decodedCtx) {
        return {
            ctx: decodedCtx,
            isOtip: OTIP_ENTITY.includes(decodedCtx.entityId),
            ctxQueryString: storedCtx,
        };
    }

    sessionStorage.removeItem(APP_CONSTANTS.MPROFILE_CTX); // Remove invalid context from sessionStorage
    return { ctx: null, isOtip: undefined, ctxQueryString: null }; // Default state if no context is found or context is invalid
};

/**
 * @description Action creator for storing the context.
 * @param {object} logger
 * @returns {object} Redux action
 */
export const StoreContext = (logger) => {
    const contextState = initializeContextState(logger);
    return {
        type: ACTION_NAME,
        payload: contextState,
    };
};

/**
 * @description Reducer to handle the action of storing the context.
 * @param {object} state
 */
export const reducer = produce((state, action) => {
    state.Context = action.payload;
});

// Register Reducers with Redux root reducer
registerReducer(ACTION_NAME, reducer);
